import React, { ChangeEvent } from 'react'
import { CheckBoxProps } from './CheckBox.props'
import { CheckBoxLabel, CheckBoxInput, CheckBoxMark } from './CheckBox.styled'

const CheckBox = ({
  text,
  name,
  value,
  checked,
  weight = '400',
  onChange,
  disabled,
}: CheckBoxProps) => {

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange && onChange(evt.target.checked ? evt.target.value : null)
    }
  }

  return (
    <CheckBoxLabel weight={weight}>
      {text}
      <CheckBoxInput
        type="checkbox"
        name={name}
        checked={checked}
        onChange={handleChange}
        value={value}
        disabled={disabled}
      />
      <CheckBoxMark></CheckBoxMark>
    </CheckBoxLabel>
  )
}

export default CheckBox
